import { AnimatePresence, motion } from 'framer-motion'

import { fadeSlideUp } from '../../animations'
import { cn } from '../../utils/cn'

interface TextIconSwapAnimationProps {
  children: React.ReactNode
  animationKey: string
  className?: string
  duration?: number
}

export const TextIconSwapAnimation = ({
  children,
  animationKey,
  className,
  duration = 0.35
}: TextIconSwapAnimationProps) => {
  return (
    <AnimatePresence mode="popLayout" initial={false}>
      <motion.div
        className={cn('flex items-center gap-1', className)}
        key={animationKey}
        {...fadeSlideUp}
        animate={{
          ...fadeSlideUp.animate,
          transition: {
            delay: duration / 1.75
          }
        }}
        transition={{
          type: 'spring',
          bounce: 0,
          duration
        }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  )
}
